import React from 'react';
import { UserError } from './UserError';
const ErrorPopup = ({ customerSupportEmail, error }) => {
    return (React.createElement(UserError, { customerSupportEmail: customerSupportEmail, error: error }));
};
export default ErrorPopup;
